import axios from '@axios';

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetchBookings(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/bookings', { params: queryParams })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        fetchBooking(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/booking/${id}/edit`)
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        sendSurveyByMail(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/booking/${id}/send-survey-by-mail`)
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        sendSurveyByWhatsapp(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/booking/${id}/send-survey-by-whatsapp`)
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        deleteBooking(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/booking/${id}/delete`)
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        }
    }
}